module.exports = __webpack_public_path__ + "blissweb-lt.67386ead3fd7ba4953e6.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/BlissWeb-Lt/blissweb-lt.ttf
// module id = 476
// module chunks = 5